import { IPage } from '@types'
import Layout from 'components/layouts/Layout'
import CateringView from 'components/services/CateringView'
import { generateStaticProps } from 'lib/generateStaticProps'
import { getAbout } from 'lib/getAbout'
import { getServices } from 'lib/getServices'
import { assocPath } from 'lib/utils'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'

export let getStaticProps = async (ctx: GetStaticPropsContext) => {
  let staticProps = await generateStaticProps(ctx, 'catering')

  let about = await getAbout('ru')
  let events = about.filter((i) => i.type === 'photoreport')
  // let thanks = about.filter((i) => i.type === 'thanks')
  let services = await getServices('ru')

  let result = {
    ...staticProps,
    props: { ...staticProps.props, events, services },
  }

  return assocPath(
    'props.contentSplitted',
    result.props.content?.split('<!--divider-->'),
    result
  )
}

export type CateringPageProps = InferGetStaticPropsType<
  typeof getStaticProps
> & { contentSplitted: string[] }

let CateringPage: IPage<CateringPageProps> = ({
  contentSplitted,
  services,
  menus,
  name,
}) => (
  <CateringView
    services={services}
    menusSSR={menus}
    content={contentSplitted}
    //thanksSSR={thanks}
    name={name}
  />
)

CateringPage.getLayout = (page: { props: CateringPageProps }) => (
  <Layout
    index
    hideBreadcrumbs
    title={page.props?.title || 'Кейтеринг'}
    description={page.props?.description}
    keywords={page.props?.keywords}
    menus={page.props.menus}
  >
    {page}
  </Layout>
)

export default CateringPage
